export enum ActionTypes {
  AUTHORIZE_USER = 'auth/AUTHORIZE_USER',
  AUTHORIZE_CLIENT = 'auth/AUTHORIZE_CLIENT',
  LOGOUT_USER = 'auth/LOGOUT_USER',
  SET_USERID = 'auth/SET_USERID',
  SET_COOKIES = 'auth/SET_COOKIES',
  SET_SERVER_DOWN = 'auth/SET_SERVER_DOWN',
  SET_IDLED = 'auth/SET_IDLED',
}

export interface OAuthData {
  token: string | undefined;
  refresh?: string;
  isLogin?: boolean;
  isAuthenticated?: boolean;
  expires: number;
  userId?: string;
  cookies?: boolean | null;
  serverDown?: boolean;
  siteStatus?: string;
  idled?: string | undefined;
}

export interface AuthorizeUserAction {
  type: ActionTypes.AUTHORIZE_USER;
  payload: OAuthData;
}
export interface SetUserId {
  type: ActionTypes.SET_USERID;
  payload: string;
}
export interface AuthorizeClientAction {
  type: ActionTypes.AUTHORIZE_CLIENT;
  payload: OAuthData;
}
export interface LogoutUserAction {
  type: ActionTypes.LOGOUT_USER;
}
export interface SetCookies {
  type: ActionTypes.SET_COOKIES;
  payload: boolean;
}
export interface SetServerDown {
  type: ActionTypes.SET_SERVER_DOWN;
  payload: boolean;
}
export interface SetIdled {
  type: ActionTypes.SET_IDLED;
  payload: string | undefined;
}

export type ActionType =
  | AuthorizeClientAction
  | AuthorizeUserAction
  | LogoutUserAction
  | SetUserId
  | SetCookies
  | SetServerDown
  | SetIdled;
